const config = window.app;
config.api.token = localStorage.getItem('token');

export default {
  name: 'Meiko M-iPlan',
  api: config.api,
  apiRoomHeatCalc: config.apiRoomHeatCalc,
  login: config.login
};
